import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1ae05a02"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "home"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "補充資料  升級體驗", -1));
const _hoisted_4 = {
  style: {
    "width": "80%",
    "margin": "auto",
    "margin-top": "30px"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_row = _resolveComponent("van-row");
  const _component_phone_input = _resolveComponent("phone-input");
  const _component_van_button = _resolveComponent("van-button");
  const _component_van_dialog = _resolveComponent("van-dialog");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_row, {
    class: "title",
    justify: "center"
  }, {
    default: _withCtx(() => [_createTextVNode(" Parent Net 教圖家長會 ")]),
    _: 1
  }), _hoisted_2, _createVNode(_component_van_row, {
    justify: "center",
    style: {
      "text-align": "center",
      "line-height": "25px",
      "font-weight": "600",
      "margin": "0 5px"
    }
  }, {
    default: _withCtx(() => [_createTextVNode(" 由香港教育圖書有限公司創建，提供育兒、升學、出版、各項優惠及服務信息等，務求與家長建立長久而貼心的服務及友好關係。 ")]),
    _: 1
  }), _createVNode(_component_van_row, {
    justify: "center",
    style: {
      "text-align": "center",
      "padding": "0 0"
    }
  }, {
    default: _withCtx(() => [_hoisted_3]),
    _: 1
  }), _createVNode(_component_phone_input, {
    phone: $data.tel,
    "onUpdate:phone": _cache[0] || (_cache[0] = $event => $data.tel = $event),
    labelText: "註冊手機號碼",
    ref: "phoneInput",
    onValidateResult: $options.nextClick
  }, null, 8, ["phone", "onValidateResult"]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_van_button, {
    type: "primary",
    size: "large",
    round: "",
    color: "#633b5b",
    onClick: $options.nextCheck,
    loading: $data.buttonL,
    "loading-text": "載入中..."
  }, {
    default: _withCtx(() => [_createTextVNode("下一步")]),
    _: 1
  }, 8, ["onClick", "loading"])]), _createVNode(_component_van_dialog, {
    show: $data.show,
    "onUpdate:show": _cache[1] || (_cache[1] = $event => $data.show = $event),
    title: "",
    confirmButtonText: "打開app",
    onConfirm: $options.opepApp
  }, {
    default: _withCtx(() => [_createVNode(_component_van_row, {
      justify: "center",
      style: {
        "text-align": "center",
        "padding": "20px 0"
      }
    }, {
      default: _withCtx(() => [_createTextVNode(" 您已補充資料，快打開APP體驗一下吧 ")]),
      _: 1
    })]),
    _: 1
  }, 8, ["show", "onConfirm"])]);
}